import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "../Typography";

const styles = theme => ({
  rootContainer: {
    position: "relative"
  },
  formControl: {
    minWidth: 120,
    width: "100%",
    marginTop: 24
  },
  icon: {
    color: "#000",
    fontSize: 24
  },
  selectMenu: {
    height: "24px",
    lineHeight: "24px",
    fontSize: "16px"
  },
  dropdownStyle: {
    boxShadow: "none",
    border: "1px solid #EEE",
    background: "#FFF"
  },
  dropdownHeight: {
    height: "200px"
  },
  menuItem: {
    fontSize: "16px",
    padding: "0px 16px 0px 16px",
    "&:hover": {
      background: "#f5f5f5"
    }
  },
  selectedItem: {
    fontWeight: 600
  }
});

class SimpleSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOpen = () => {
    this.setState({
      open: true
    });
  };

  render() {
    const {
      classes,
      topLabel,
      bottomLabel,
      name,
      values,
      selected_value,
      handleChange
    } = this.props;

    const { open } = this.state;

    return (
      <div className={classes.rootContainer}>
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-controlled-open-select-label">
            {topLabel}
          </InputLabel>
          <Select
            labelId="simple-select"
            id="simple-select"
            inputProps={{
              id: "simple-select",
              name: name
            }}
            open={open}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            value={selected_value}
            onChange={handleChange}
            classes={{
              icon: classes.icon,
              selectMenu: classes.selectMenu
            }}
            MenuProps={{
              classes: {
                paper:
                  values.length >= 4
                    ? `${classes.dropdownStyle} ${classes.dropdownHeight}`
                    : `${classes.dropdownStyle}`
              }
            }}
          >
            {values &&
              values.map((val, i) => (
                <MenuItem
                  key={"item" + i}
                  classes={{
                    root:
                      val === selected_value
                        ? `${classes.menuItem} ${classes.selectedItem}`
                        : `${classes.menuItem}`
                  }}
                  value={val}
                >
                  {val}
                </MenuItem>
              ))}
          </Select>
          <Typography
            type="body2"
            color="deepGrey"
            className={classes.marginTop}
          >
            {bottomLabel}
          </Typography>
        </FormControl>
      </div>
    );
  }
}

SimpleSelect.propTypes = {
  topLabel: PropTypes.string.isRequired,
  bottomLabel: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  selected_value: PropTypes.string.isRequired,
  handleChange: PropTypes.func
};

SimpleSelect.defaultProps = {
  topLabel: "Select: ",
  bottomLabel: "Please select the value",
  name: "day",
  values: ["Mon", "Tue", "Wed", "Thr", "Fri", "Sat", "Sun"],
  selected_value: "Mon"
};

export default withStyles(styles)(SimpleSelect);
